// Auto-generated from backend data
// 'name' field is for search display (includes brand prefix for searchability)
// 'exactName' field is the exact backend model name for matching

const searchData = {
  // Phone categories
  huawei: [
    { name: 'Huawei Honor 200 Pro', exactName: 'Honor 200 Pro', image: '' },
    { name: 'Huawei Honor 200 Smart', exactName: 'Honor 200 Smart', image: '' },
    { name: 'Huawei Honor 200 Lite', exactName: 'Honor 200 Lite', image: '' },
    { name: 'Huawei Honor 90', exactName: 'Honor 90', image: '' },
    { name: 'Huawei Magic 6 Lite', exactName: 'Magic 6 Lite', image: '' },
    { name: 'Huawei Magic 5 Lite', exactName: 'Magic 5 Lite', image: '' },
    { name: 'Huawei P30 Pro', exactName: 'P30 Pro', image: '' },
    { name: 'Huawei Honor 90 Lite', exactName: 'Honor 90 Lite', image: '' },
    { name: 'Huawei Honor 9x', exactName: 'Honor 9x', image: '' },
    { name: 'Huawei P30', exactName: 'P30', image: '' },
    { name: 'Huawei P30 Lite', exactName: 'P30 Lite', image: '' },
    { name: 'Huawei Mate 20 Pro', exactName: 'Mate 20 Pro', image: '' },
    { name: 'Huawei Mate 20', exactName: 'Mate 20', image: '' },
    { name: 'Huawei P20 Pro', exactName: 'P20 Pro', image: '' },
    { name: 'Huawei P20 Lite', exactName: 'P20 Lite', image: '' },
    { name: 'Huawei P20', exactName: 'P20', image: '' },
    { name: 'Huawei Y6', exactName: 'Y6', image: '' },
    { name: 'Huawei P Smart (2018)', exactName: 'P Smart (2018)', image: '' },
    { name: 'Huawei P Smart (2019)', exactName: 'P Smart (2019)', image: '' },
    { name: 'Huawei Y9s', exactName: 'Y9s', image: '' },
    { name: 'Huawei Y9se', exactName: 'Y9se', image: '' },
    { name: 'Huawei Y9a', exactName: 'Y9a', image: '' },
    { name: 'Huawei Y70', exactName: 'Y70', image: '' },
    { name: 'Huawei P Smart (2020)', exactName: 'P Smart (2020)', image: '' },
    { name: 'Huawei Honor X7A', exactName: 'Honor X7A', image: '' },
    { name: 'Huawei Honor X6A', exactName: 'Honor X6A', image: '' },
    { name: 'Huawei Honor X9A', exactName: 'Honor X9A', image: '' },
    { name: 'Huawei Honor X8A', exactName: 'Honor X8A', image: '' },
    { name: 'Huawei Honor X9', exactName: 'Honor X9', image: '' },
    { name: 'Huawei Y6 (2019)', exactName: 'Y6 (2019)', image: '' },
    { name: 'Huawei Honor X8', exactName: 'Honor X8', image: '' },
    { name: 'Huawei Honor X7B', exactName: 'Honor X7B', image: '' },
    { name: 'Huawei Y9', exactName: 'Y9', image: '' },
    { name: 'Huawei Honor Nova 9se', exactName: 'Honor Nova 9se', image: '' },
    { name: 'Huawei Honor 10', exactName: 'Honor 10', image: '' },
    { name: 'Huawei Honor Y7A', exactName: 'Honor Y7A', image: '' },
    { name: 'Huawei Honor Y8A', exactName: 'Honor Y8A', image: '' },
    { name: 'Huawei Honor Y8P', exactName: 'Honor Y8P', image: '' },
    { name: 'Huawei Honor x9', exactName: 'Honor x9', image: '' },
    { name: 'Huawei Honor Y60', exactName: 'Honor Y60', image: '' },
    { name: 'Huawei Honor Y61', exactName: 'Honor Y61', image: '' },
  ],
  iphone: [
    { name: 'iPhone 15', exactName: 'iPhone 15', image: '' },
    { name: 'iPhone 15 plus', exactName: 'iPhone 15 plus', image: '' },
    { name: 'iPhone 14 pro max', exactName: 'iPhone 14 pro max', image: '' },
    { name: 'iPhone 16 pro max', exactName: 'iPhone 16 pro max', image: '' },
    { name: 'iPhone 16 pro', exactName: 'iPhone 16 pro', image: '' },
    { name: 'iPhone 16 plus', exactName: 'iPhone 16 plus', image: '' },
    { name: 'iPhone 16', exactName: 'iPhone 16', image: '' },
    { name: 'iPhone 15 pro max', exactName: 'iPhone 15 pro max', image: '' },
    { name: 'iPhone 14 pro', exactName: 'iPhone 14 pro', image: '' },
    { name: 'iPhone 14 plus', exactName: 'iPhone 14 plus', image: '' },
    { name: 'iPhone 14', exactName: 'iPhone 14', image: '' },
    { name: 'iPhone 13 pro max', exactName: 'iPhone 13 pro max', image: '' },
    { name: 'iPhone 13 pro', exactName: 'iPhone 13 pro', image: '' },
    { name: 'iPhone 13', exactName: 'iPhone 13', image: '' },
    { name: 'iPhone 13 mini', exactName: 'iPhone 13 mini', image: '' },
    { name: 'iPhone 12 pro max', exactName: 'iPhone 12 pro max', image: '' },
    { name: 'iPhone 12 pro', exactName: 'iPhone 12 pro', image: '' },
    { name: 'iPhone 12', exactName: 'iPhone 12', image: '' },
    { name: 'iPhone 12 mini', exactName: 'iPhone 12 mini', image: '' },
    { name: 'iPhone 11 pro max', exactName: 'iPhone 11 pro max', image: '' },
    { name: 'iPhone 11 pro', exactName: 'iPhone 11 pro', image: '' },
    { name: 'iPhone 11', exactName: 'iPhone 11', image: '' },
    { name: 'iPhone SE 3 (2022)', exactName: 'iPhone SE 3 (2022)', image: '' },
    { name: 'iPhone SE (2nd generation)', exactName: 'iPhone SE (2nd generation)', image: '' },
    { name: 'iPhone X', exactName: 'iPhone X', image: '' },
    { name: 'iPhone XS Max', exactName: 'iPhone XS Max', image: '' },
    { name: 'iPhone XS', exactName: 'iPhone XS', image: '' },
    { name: 'iPhone XR', exactName: 'iPhone XR', image: '' },
    { name: 'iPhone 8 plus', exactName: 'iPhone 8 plus', image: '' },
    { name: 'iPhone 8', exactName: 'iPhone 8', image: '' },
    { name: 'iPhone 7', exactName: 'iPhone 7', image: '' },
    { name: 'iPhone 7 plus', exactName: 'iPhone 7 plus', image: '' },
    { name: 'iPhone 6s plus', exactName: 'iPhone 6s plus', image: '' },
    { name: 'iPhone 6 plus', exactName: 'iPhone 6 plus', image: '' },
    { name: 'iPhone 6s', exactName: 'iPhone 6s', image: '' },
    { name: 'iPhone 6', exactName: 'iPhone 6', image: '' },
    { name: 'iPhone 5c', exactName: 'iPhone 5c', image: '' },
    { name: 'iPhone 5s', exactName: 'iPhone 5s', image: '' },
    { name: 'iPhone 5', exactName: 'iPhone 5', image: '' },
    { name: 'iPhone 4s', exactName: 'iPhone 4s', image: '' },
    { name: 'iPhone 4', exactName: 'iPhone 4', image: '' },
  ],
  motorola: [
    { name: 'Motorola G34', exactName: 'Motorola G34', image: '' },
    { name: 'Motorola G62', exactName: 'Motorola G62', image: '' },
    { name: 'Motorola G04', exactName: 'Motorola G04', image: '' },
    { name: 'Motorola G84', exactName: 'Motorola G84', image: '' },
    { name: 'Motorola G 5g (2024)', exactName: 'Motorola G 5g (2024)', image: '' },
    { name: 'Motorola G54', exactName: 'Motorola G54', image: '' },
    { name: 'Motorola e20', exactName: 'Motorola e20', image: '' },
    { name: 'Motorola G30', exactName: 'Motorola G30', image: '' },
    { name: 'Motorola E40', exactName: 'Motorola E40', image: '' },
    { name: 'Motorola G7', exactName: 'Motorola G7', image: '' },
    { name: 'Motorola G7 plus', exactName: 'Motorola G7 plus', image: '' },
    { name: 'Motorola G8', exactName: 'Motorola G8', image: '' },
    { name: 'Motorola G8 play', exactName: 'Motorola G8 play', image: '' },
    { name: 'Motorola G8 plus', exactName: 'Motorola G8 plus', image: '' },
    { name: 'Motorola G9', exactName: 'Motorola G9', image: '' },
    { name: 'Motorola G9 play', exactName: 'Motorola G9 play', image: '' },
    { name: 'Motorola E13', exactName: 'Motorola E13', image: '' },
    { name: 'Motorola E22', exactName: 'Motorola E22', image: '' },
    { name: 'Motorola G22', exactName: 'Motorola G22', image: '' },
    { name: 'Motorola G42', exactName: 'Motorola G42', image: '' },
    { name: 'Motorola G52', exactName: 'Motorola G52', image: '' },
    { name: 'Motorola G53', exactName: 'Motorola G53', image: '' },
    { name: 'Motorola G200', exactName: 'Motorola G200', image: '' },
    { name: 'Motorola G70', exactName: 'Motorola G70', image: '' },
    { name: 'Motorola G60 s', exactName: 'Motorola G60 s', image: '' },
    { name: 'Motorola G9 plus', exactName: 'Motorola G9 plus', image: '' },
    { name: 'Motorola G9 power', exactName: 'Motorola G9 power', image: '' },
    { name: 'Motorola C', exactName: 'Motorola C', image: '' },
    { name: 'Motorola E5', exactName: 'Motorola E5', image: '' },
    { name: 'Motorola E5 play', exactName: 'Motorola E5 play', image: '' },
    { name: 'Motorola E5 go', exactName: 'Motorola E5 go', image: '' },
    { name: 'Motorola E6', exactName: 'Motorola E6', image: '' },
    { name: 'Motorola E6 plus', exactName: 'Motorola E6 plus', image: '' },
    { name: 'Motorola E6 s', exactName: 'Motorola E6 s', image: '' },
    { name: 'Motorola E7', exactName: 'Motorola E7', image: '' },
    { name: 'Motorola E7 plus', exactName: 'Motorola E7 plus', image: '' },
    { name: 'Motorola E7 i', exactName: 'Motorola E7 i', image: '' },
    { name: 'Motorola G10', exactName: 'Motorola G10', image: '' },
    { name: 'Motorola G100', exactName: 'Motorola G100', image: '' },
    { name: 'Motorola G50', exactName: 'Motorola G50', image: '' },
    { name: 'Motorola G6 play', exactName: 'Motorola G6 play', image: '' },
    { name: 'Motorola G7 play', exactName: 'Motorola G7 play', image: '' },
    { name: 'Motorola G5 plus', exactName: 'Motorola G5 plus', image: '' },
    { name: 'Motorola G 5g plus', exactName: 'Motorola G 5g plus', image: '' },
    { name: 'Motorola G8 power', exactName: 'Motorola G8 power', image: '' },
    { name: 'Motorola E14', exactName: 'Motorola E14', image: '' },
    { name: 'Motorola G35', exactName: 'Motorola G35', image: '' },
  ],
  nokia: [
    { name: 'Nokia 8.1', exactName: 'Nokia 8.1', image: '' },
    { name: 'Nokia 7.2', exactName: 'Nokia 7.2', image: '' },
    { name: 'Nokia 7.1', exactName: 'Nokia 7.1', image: '' },
    { name: 'Nokia 7', exactName: 'Nokia 7', image: '' },
    { name: 'Nokia 6.2', exactName: 'Nokia 6.2', image: '' },
    { name: 'Nokia 6.1', exactName: 'Nokia 6.1', image: '' },
    { name: 'Nokia 6', exactName: 'Nokia 6', image: '' },
    { name: 'Nokia 5.4', exactName: 'Nokia 5.4', image: '' },
    { name: 'Nokia 5.1 plus', exactName: 'Nokia 5.1 plus', image: '' },
    { name: 'Nokia 5.1', exactName: 'Nokia 5.1', image: '' },
    { name: 'Nokia 5', exactName: 'Nokia 5', image: '' },
    { name: 'Nokia 4.2', exactName: 'Nokia 4.2', image: '' },
    { name: 'Nokia 3.4', exactName: 'Nokia 3.4', image: '' },
    { name: 'Nokia 3.2', exactName: 'Nokia 3.2', image: '' },
    { name: 'Nokia 3.1 plus', exactName: 'Nokia 3.1 plus', image: '' },
    { name: 'Nokia 3', exactName: 'Nokia 3', image: '' },
    { name: 'Nokia 2.4', exactName: 'Nokia 2.4', image: '' },
    { name: 'Nokia 2.3', exactName: 'Nokia 2.3', image: '' },
    { name: 'Nokia 2.2', exactName: 'Nokia 2.2', image: '' },
    { name: 'Nokia 2', exactName: 'Nokia 2', image: '' },
    { name: 'Nokia 1', exactName: 'Nokia 1', image: '' },
    { name: 'Nokia x7', exactName: 'Nokia x7', image: '' },
    { name: 'Nokia x6', exactName: 'Nokia x6', image: '' },
    { name: 'Nokia x20', exactName: 'Nokia x20', image: '' },
    { name: 'Nokia G22', exactName: 'Nokia G22', image: '' },
    { name: 'Nokia G21', exactName: 'Nokia G21', image: '' },
    { name: 'Nokia C30', exactName: 'Nokia C30', image: '' },
    { name: 'Nokia C21 plus', exactName: 'Nokia C21 plus', image: '' },
    { name: 'Nokia C01 plus', exactName: 'Nokia C01 plus', image: '' },
    { name: 'Nokia C22', exactName: 'Nokia C22', image: '' },
    { name: 'Nokia C32', exactName: 'Nokia C32', image: '' },
  ],
  oneplus: [
    { name: 'OnePlus Nord 5g', exactName: 'Oneplus Nord 5g', image: '' },
    { name: 'OnePlus 8 pro', exactName: 'Oneplus 8 pro', image: '' },
    { name: 'OnePlus 8t', exactName: 'Oneplus 8t', image: '' },
    { name: 'OnePlus 8', exactName: 'Oneplus 8', image: '' },
    { name: 'OnePlus 7t pro 5g', exactName: 'Oneplus 7t pro 5g', image: '' },
    { name: 'OnePlus 7t', exactName: 'Oneplus 7t', image: '' },
    { name: 'OnePlus 7 pro', exactName: 'Oneplus 7 pro', image: '' },
    { name: 'OnePlus 7', exactName: 'Oneplus 7', image: '' },
    { name: 'OnePlus 6t Mclaren', exactName: 'Oneplus 6t Mclaren', image: '' },
    { name: 'OnePlus 6t', exactName: 'Oneplus 6t', image: '' },
    { name: 'OnePlus 6', exactName: 'Oneplus 6', image: '' },
    { name: 'OnePlus 5t', exactName: 'Oneplus 5t', image: '' },
    { name: 'OnePlus 5', exactName: 'Oneplus 5', image: '' },
    { name: 'OnePlus 3t', exactName: 'Oneplus 3t', image: '' },
    { name: 'OnePlus 3', exactName: 'Oneplus 3', image: '' },
    { name: 'OnePlus Nord', exactName: 'Oneplus Nord', image: '' },
    { name: 'OnePlus Nord n10 5g', exactName: 'Oneplus Nord n10 5g', image: '' },
    { name: 'OnePlus one', exactName: 'Oneplus one', image: '' },
  ],
  oppo: [
    { name: 'Oppo A96', exactName: 'A96', image: '' },
    { name: 'Oppo A94 4g', exactName: 'A94 4g', image: '' },
    { name: 'Oppo A77 5g', exactName: 'A77 5g', image: '' },
    { name: 'Oppo A76', exactName: 'A76', image: '' },
    { name: 'Oppo A74 5g', exactName: 'A74 5g', image: '' },
    { name: 'Oppo A74 4g', exactName: 'A74 4g', image: '' },
    { name: 'Oppo A73 5g', exactName: 'A73 5g', image: '' },
    { name: 'Oppo A59', exactName: 'A59', image: '' },
    { name: 'Oppo Realme 8 5g', exactName: 'Realme 8 5g', image: '' },
    { name: 'Oppo A72', exactName: 'A72', image: '' },
    { name: 'Oppo A53', exactName: 'A53', image: '' },
    { name: 'Oppo AX7', exactName: 'AX7', image: '' },
  ],
  pixel: [
    { name: 'Google Pixel 9 pro xl', exactName: 'Pixel 9 pro xl', image: '' },
    { name: 'Google Pixel 9 pro', exactName: 'Pixel 9 pro', image: '' },
    { name: 'Google Pixel 8a', exactName: 'Pixel 8a', image: '' },
    { name: 'Google Pixel 8', exactName: 'Pixel 8', image: '' },
    { name: 'Google Pixel 8 pro', exactName: 'Pixel 8 pro', image: '' },
    { name: 'Google Pixel 6 pro', exactName: 'Pixel 6 pro', image: '' },
    { name: 'Google Pixel 6a', exactName: 'Pixel 6a', image: '' },
    { name: 'Google Pixel 6', exactName: 'Pixel 6', image: '' },
    { name: 'Google Pixel 5a', exactName: 'Pixel 5a', image: '' },
    { name: 'Google Pixel 5', exactName: 'Pixel 5', image: '' },
    { name: 'Google Pixel 4a', exactName: 'Pixel 4a', image: '' },
    { name: 'Google Pixel 4a 5g', exactName: 'Pixel 4a 5g', image: '' },
    { name: 'Google Pixel 4 5g', exactName: 'Pixel 4 5g', image: '' },
    { name: 'Google Pixel 4 xl', exactName: 'Pixel 4 xl', image: '' },
    { name: 'Google Pixel 4', exactName: 'Pixel 4', image: '' },
    { name: 'Google Pixel 3a xl', exactName: 'Pixel 3a xl', image: '' },
    { name: 'Google Pixel 3a', exactName: 'Pixel 3a', image: '' },
    { name: 'Google Pixel 3 xl', exactName: 'Pixel 3 xl', image: '' },
    { name: 'Google Pixel 3', exactName: 'Pixel 3', image: '' },
    { name: 'Google Pixel 2 xl', exactName: 'Pixel 2 xl', image: '' },
    { name: 'Google Pixel 2', exactName: 'Pixel 2', image: '' },
    { name: 'Google Pixel 7', exactName: 'Pixel 7', image: '' },
    { name: 'Google Pixel 7 Pro', exactName: 'Pixel 7 Pro', image: '' },
    { name: 'Google Pixel 7a', exactName: 'Pixel 7a', image: '' },
  ],
  samsung: [
    { name: 'Samsung Galaxy S24 Ultra', exactName: 'Galaxy S24 Ultra', image: '' },
    { name: 'Samsung Galaxy S24 Plus', exactName: 'Galaxy S24 Plus', image: '' },
    { name: 'Samsung Galaxy S24', exactName: 'Galaxy S24', image: '' },
    { name: 'Samsung Galaxy S23 Ultra', exactName: 'Galaxy S23 Ultra', image: '' },
    { name: 'Samsung Galaxy S23 Plus', exactName: 'Galaxy S23 Plus', image: '' },
    { name: 'Samsung Galaxy S23', exactName: 'Galaxy S23', image: '' },
    { name: 'Samsung Galaxy S22 Ultra', exactName: 'Galaxy S22 Ultra', image: '' },
    { name: 'Samsung Galaxy S22 Plus', exactName: 'Galaxy S22 Plus', image: '' },
    { name: 'Samsung Galaxy S22', exactName: 'Galaxy S22', image: '' },
    { name: 'Samsung Galaxy S21 Ultra', exactName: 'Galaxy S21 Ultra', image: '' },
    { name: 'Samsung Galaxy S21 FE', exactName: 'Galaxy S21 FE', image: '' },
    { name: 'Samsung Galaxy S21 Plus', exactName: 'Galaxy S21 Plus', image: '' },
    { name: 'Samsung Galaxy S21', exactName: 'Galaxy S21', image: '' },
    { name: 'Samsung Galaxy S20 Ultra', exactName: 'Galaxy S20 Ultra', image: '' },
    { name: 'Samsung Galaxy S20 plus', exactName: 'Galaxy S20 plus', image: '' },
    { name: 'Samsung Galaxy S20 fe', exactName: 'Galaxy S20 fe', image: '' },
    { name: 'Samsung Galaxy S20', exactName: 'Galaxy S20', image: '' },
    { name: 'Samsung Galaxy S10 5g', exactName: 'Galaxy S10 5g', image: '' },
    { name: 'Samsung Galaxy S10 plus', exactName: 'Galaxy S10 plus', image: '' },
    { name: 'Samsung Galaxy S10', exactName: 'Galaxy S10', image: '' },
    { name: 'Samsung Galaxy S10 e', exactName: 'Galaxy S10 e', image: '' },
    { name: 'Samsung Galaxy S10 lite', exactName: 'Galaxy S10 lite', image: '' },
    { name: 'Samsung Galaxy S9 plus', exactName: 'Galaxy S9 plus', image: '' },
    { name: 'Samsung Galaxy S9', exactName: 'Galaxy S9', image: '' },
    { name: 'Samsung Galaxy S8 plus', exactName: 'Galaxy S8 plus', image: '' },
    { name: 'Samsung Galaxy S8', exactName: 'Galaxy S8', image: '' },
    { name: 'Samsung Galaxy S7 edge', exactName: 'Galaxy S7 edge', image: '' },
    { name: 'Samsung Galaxy S7', exactName: 'Galaxy S7', image: '' },
    { name: 'Samsung Galaxy S6', exactName: 'Galaxy S6', image: '' },
    { name: 'Samsung Galaxy S6 edge', exactName: 'Galaxy S6 edge', image: '' },
    { name: 'Samsung Galaxy note 20 Ultra', exactName: 'Galaxy note 20 Ultra', image: '' },
    { name: 'Samsung Galaxy note 20', exactName: 'Galaxy note 20', image: '' },
    { name: 'Samsung Galaxy note 10 plus 5g', exactName: 'Galaxy note 10 plus 5g', image: '' },
    { name: 'Samsung Galaxy note 10 plus', exactName: 'Galaxy note 10 plus', image: '' },
    { name: 'Samsung Galaxy note 10', exactName: 'Galaxy note 10', image: '' },
    { name: 'Samsung Galaxy note 10 lite', exactName: 'Galaxy note 10 lite', image: '' },
    { name: 'Samsung Galaxy note 9', exactName: 'Galaxy note 9', image: '' },
    { name: 'Samsung Galaxy note 8', exactName: 'Galaxy note 8', image: '' },
    { name: 'Samsung A73', exactName: 'Samsung A73', image: '' },
    { name: 'Samsung A72', exactName: 'Samsung A72', image: '' },
    { name: 'Samsung A71', exactName: 'Samsung A71', image: '' },
    { name: 'Samsung A70', exactName: 'Samsung A70', image: '' },
    { name: 'Samsung A55', exactName: 'Samsung A55', image: '' },
    { name: 'Samsung A54', exactName: 'Samsung A54', image: '' },
    { name: 'Samsung A53', exactName: 'Samsung A53', image: '' },
    { name: 'Samsung A52s 5G', exactName: 'Samsung A52s 5G', image: '' },
    { name: 'Samsung A52 4G', exactName: 'Samsung A52 4G', image: '' },
    { name: 'Samsung A51 5G', exactName: 'Samsung A51 5G', image: '' },
    { name: 'Samsung A50', exactName: 'Samsung A50', image: '' },
    { name: 'Samsung A42 5G', exactName: 'Samsung A42 5G', image: '' },
    { name: 'Samsung A41', exactName: 'Samsung A41', image: '' },
    { name: 'Samsung A40', exactName: 'Samsung A40', image: '' },
    { name: 'Samsung A35', exactName: 'Samsung A35', image: '' },
    { name: 'Samsung A34 5G', exactName: 'Samsung A34 5G', image: '' },
    { name: 'Samsung A33', exactName: 'Samsung A33', image: '' },
    { name: 'Samsung Galaxy A32 5G', exactName: 'Samsung Galaxy A32 5G', image: '' },
    { name: 'Samsung A32 4G', exactName: 'Samsung A32 4G', image: '' },
    { name: 'Samsung A31', exactName: 'Samsung A31', image: '' },
    { name: 'Samsung A30', exactName: 'Samsung A30', image: '' },
    { name: 'Samsung A25', exactName: 'Samsung A25', image: '' },
    { name: 'Samsung A24', exactName: 'Samsung A24', image: '' },
    { name: 'Samsung A23', exactName: 'Samsung A23', image: '' },
    { name: 'Samsung A22 5G', exactName: 'Samsung A22 5G', image: '' },
    { name: 'Samsung A22 4G', exactName: 'Samsung A22 4G', image: '' },
    { name: 'Samsung A21S', exactName: 'Samsung A21S', image: '' },
    { name: 'Samsung A20S', exactName: 'Samsung A20S', image: '' },
    { name: 'Samsung A20E', exactName: 'Samsung A20E', image: '' },
    { name: 'Samsung A20', exactName: 'Samsung A20', image: '' },
    { name: 'Samsung A15 5G', exactName: 'Samsung A15 5G', image: '' },
    { name: 'Samsung A15', exactName: 'Samsung A15', image: '' },
    { name: 'Samsung A14', exactName: 'Samsung A14', image: '' },
    { name: 'Samsung A13', exactName: 'Samsung A13', image: '' },
    { name: 'Samsung A12', exactName: 'Samsung A12', image: '' },
    { name: 'Samsung A11', exactName: 'Samsung A11', image: '' },
    { name: 'Samsung A10S', exactName: 'Samsung A10S', image: '' },
    { name: 'Samsung A10', exactName: 'Samsung A10', image: '' },
    { name: 'Samsung A9', exactName: 'Samsung A9', image: '' },
    { name: 'Samsung A8', exactName: 'Samsung A8', image: '' },
    { name: 'Samsung A7', exactName: 'Samsung A7', image: '' },
    { name: 'Samsung A6', exactName: 'Samsung A6', image: '' },
    { name: 'Samsung A05', exactName: 'Samsung A05', image: '' },
    { name: 'Samsung Galaxy J6', exactName: 'Samsung Galaxy J6', image: '' },
    { name: 'Samsung Galaxy J5 2017', exactName: 'Samsung Galaxy J5 2017', image: '' },
    { name: 'Samsung Galaxy J5', exactName: 'Samsung Galaxy J5', image: '' },
    { name: 'Samsung Galaxy J4', exactName: 'Samsung Galaxy J4', image: '' },
    { name: 'Samsung Galaxy J3 2017', exactName: 'Samsung Galaxy J3 2017', image: '' },
    { name: 'Samsung Z Flip 6', exactName: 'Samsung Z Flip 6', image: '' },
    { name: 'Samsung Z Flip 5', exactName: 'Samsung Z Flip 5', image: '' },
    { name: 'Samsung Z Flip 4', exactName: 'Samsung Z Flip 4', image: '' },
    { name: 'Samsung Z Flip 3', exactName: 'Samsung Z Flip 3', image: '' },
    { name: 'Samsung Z Fold 6', exactName: 'Samsung Z Fold 6', image: '' },
    { name: 'Samsung Z Flip 1', exactName: 'Samsung Z Flip 1', image: '' },
    { name: 'Samsung Z Flip 2', exactName: 'Samsung Z Flip 2', image: '' },
    { name: 'Samsung Z Fold 1', exactName: 'Samsung Z Fold 1', image: '' },
    { name: 'Samsung Z Fold 2', exactName: 'Samsung Z Fold 2', image: '' },
    { name: 'Samsung Z Fold 5', exactName: 'Samsung Z Fold 5', image: '' },
    { name: 'Samsung Z Fold 4', exactName: 'Samsung Z Fold 4', image: '' },
    { name: 'Samsung Z Fold 3', exactName: 'Samsung Z Fold 3', image: '' },
  ],
  xiaomi: [
    { name: 'Redmi Note 13 4G', exactName: 'Note 13 4G', image: '' },
    { name: 'Redmi Note 13 5G', exactName: 'Note 13 5G', image: '' },
    { name: 'Redmi Note 10 s', exactName: 'Note 10 s', image: '' },
    { name: 'Redmi Note 12 pro 4G', exactName: 'Note 12 pro 4G', image: '' },
    { name: 'Redmi Note 11 pro', exactName: 'Note 11 pro', image: '' },
    { name: 'Redmi Note 9', exactName: 'Note 9', image: '' },
    { name: 'Redmi Note 8', exactName: 'Note 8', image: '' },
    { name: 'Redmi Note 7', exactName: 'Note 7', image: '' },
    { name: 'Redmi Note 11', exactName: 'Note 11', image: '' },
    { name: 'Redmi Note 10 pro 4g', exactName: 'Note 10 pro 4g', image: '' },
  ],

  // Tablets
  ipad: [
    { name: 'IPad 2th Gen (A1397, A1396, A1395)', exactName: 'IPad 2th Gen (A1397, A1396, A1395)', image: '/images/tablet/ipad2thgen.jpg' },
    { name: 'IPad 3th Gen (A1430, A1416, A1403)', exactName: 'IPad 3th Gen (A1430, A1416, A1403)', image: '/images/tablet/ipad3rdgen.jpeg' },
    { name: 'IPad 4th Gen (A1460, A1459, A1458)', exactName: 'IPad 4th Gen (A1460, A1459, A1458)', image: '/images/tablet/ipad4thgen.jpg' },
    { name: 'IPad 5th Gen', exactName: 'IPad 5th Gen', image: '/images/tablet/ipad5thgen.webp' },
    { name: 'IPad 6th Gen (A1893-A1954)', exactName: 'IPad 6th Gen (A1893-A1954)', image: '/images/tablet/ipad6thgen.jpg' },
    { name: 'IPad 7th Gen', exactName: 'IPad 7th Gen', image: '/images/tablet/ipad7thgen.webp' },
    { name: 'IPad 8th Gen (A2270, A2428, A2429, A2430)', exactName: 'IPad 8th Gen (A2270, A2428, A2429, A2430)', image: '/images/tablet/ipad8thgen.webp' },
    { name: 'IPad 9th Gen (A2602, A2604, A2603)', exactName: 'IPad 9th Gen (A2602, A2604, A2603)', image: '/images/tablet/ipad9thgen.webp' },
    { name: 'IPad 10th Gen (A2696-A2757-A2777)', exactName: 'IPad 10th Gen (A2696-A2757-A2777)', image: '/images/tablet/ipad10thgen.webp' },
    { name: 'IPad Pro 9.7 (A1673-A1674-A1675)', exactName: 'IPad Pro 9.7 (A1673-A1674-A1675)', image: '/images/tablet/ipadpro9.7.jpg' },
    { name: 'IPad Pro 10.5 (A1701 – A1709)', exactName: 'IPad Pro 10.5 (A1701 – A1709)', image: '/images/tablet/ipadpro10.5.jpg' },
    { name: 'IPad Pro 11', exactName: 'IPad Pro 11', image: '/images/tablet/ipadpro11.jpg' },
    { name: 'IPad Pro 11 2nd Gen (A2228-A2068-A2230)', exactName: 'IPad Pro 11 2nd Gen (A2228-A2068-A2230)', image: '/images/tablet/ipadpro112ndgen.webp' },
    { name: 'IPad 12.9 1ST Gen (A1584, A1652)', exactName: 'IPad 12.9 1ST Gen (A1584, A1652)', image: '/images/tablet/ipad12.91stgen.jpg' },
    { name: 'IPad Pro 12.9 2nd Gen (A1670, A1671)', exactName: 'IPad Pro 12.9 2nd Gen (A1670, A1671)', image: '/images/tablet/ipadpro12.92ndgen.webp' },
    { name: 'IPad Pro 12.9 3rd Gen (A1876, A2014, A1895, A1983)', exactName: 'IPad Pro 12.9 3rd Gen (A1876, A2014, A1895, A1983)', image: '/images/tablet/ipadpro12.93rdgen.jpg' },
    { name: 'IPad Pro 12.9″ 4th Gen (A2229, A2069, A2232, A2233)', exactName: 'IPad Pro 12.9″ 4th Gen (A2229, A2069, A2232, A2233)', image: '/images/tablet/ipadpro12.94thgen.jpg' },
    { name: 'IPad Pro 12.9 5th Gen (A2378-A2461-A2379-A2462)', exactName: 'IPad Pro 12.9 5th Gen (A2378-A2461-A2379-A2462)', image: '/images/tablet/ipadpro12.95thgen.jpg' },
    { name: 'iPad Air 5th Gen (A2588, A2589, A2591)', exactName: 'iPad Air 5th Gen (A2588, A2589, A2591)', image: '/images/tablet/ipadair5thgen.webp' },
    { name: 'iPad Air 4th Gen (A2316, A2324, A2325, A2072)', exactName: 'iPad Air 4th Gen (A2316, A2324, A2325, A2072)', image: '/images/tablet/ipadair.png' },
    { name: 'iPad Air 3rd Gen (A2152, A2153, A2123)', exactName: 'iPad Air 3rd Gen (A2152, A2153, A2123)', image: '/images/tablet/ipadair.png' },
    { name: 'iPad Air 2 (A1566, A1567)', exactName: 'iPad Air 2 (A1566, A1567)', image: '/images/tablet/ipadair2.webp' },
    { name: 'iPad Air (A1474, A1475)', exactName: 'iPad Air (A1474, A1475)', image: '/images/tablet/ipadair.png' },
    { name: 'IPad Mini 6 (A1474-A1475-A1476)', exactName: 'IPad Mini 6 (A1474-A1475-A1476)', image: '/images/tablet/ipadmini6.webp' },
    { name: 'IPad Mini 5 (A2133-A2124-A2126)', exactName: 'IPad Mini 5 (A2133-A2124-A2126)', image: '/images/tablet/ipadmini5.webp' },
    { name: 'IPad Mini 4 (A1538-A1550)', exactName: 'IPad Mini 4 (A1538-A1550)', image: '/images/tablet/ipadmini4.webp' },
    { name: 'IPad Mini 3 (A1599, A1600)', exactName: 'IPad Mini 3 (A1599, A1600)', image: '/images/tablet/ipadmini3.webp' },
    { name: 'IPad Mini 1 & 2 (A1489, A1490, A1432, A1454)', exactName: 'IPad Mini 1 & 2 (A1489, A1490, A1432, A1454)', image: '/images/tablet/ipadmini2.jpg' },
  ],
  samsungtab: [
    { name: 'Samsung Galaxy Tab S7', exactName: 'Samsung Galaxy Tab S7', image: '/images/tablet/samsunggalaxytabs6.webp' },
    { name: 'Samsung Tab A9 Plus', exactName: 'Samsung Tab A9 Plus', image: '/images/tablet/samsunggalaxytaba7.webp' },
    { name: 'Samsung Galaxy Tab A8', exactName: 'Samsung Galaxy Tab A8', image: '/images/tablet/samsunggalaxya8.jpg' },
    { name: 'Samsung Tab A7', exactName: 'Samsung Tab A7', image: '/images/tablet/samsunggalaxytaba7.webp' },
    { name: 'Samsung Tab A7 Lite', exactName: 'Samsung Tab A7 Lite', image: '/images/tablet/samsunggalaxytaba7.webp' },
    { name: 'SAMSUNG TAB A6 2019', exactName: 'SAMSUNG TAB A6 2019', image: '/images/tablet/samsunggalaxytaba6.jpg' },
    { name: 'SAMSUNG TAB A6 T285', exactName: 'SAMSUNG TAB A6 T285', image: '/images/tablet/samsunggalaxytaba6.jpg' },
    { name: 'SAMSUNG TAB A6 T295', exactName: 'SAMSUNG TAB A6 T295', image: '/images/tablet/samsunggalaxytaba6.jpg' },
    { name: 'SAMSUNG TAB A6 T585', exactName: 'SAMSUNG TAB A6 T585', image: '/images/tablet/samsunggalaxytaba6.jpg' },
    { name: 'Samsung Tab S6 Lite', exactName: 'Samsung Tab S6 Lite', image: '/images/tablet/samsunggalaxytabs6.webp' },
  ],

  // Watches
  iwatch: [
    { name: 'IWATCH SERIES 10 (46MM)', exactName: 'IWATCH SERIES 10 (46MM)', image: '/images/watches/iwatchseries945mm.jpg' },
    { name: 'IWATCH SERIES 10 (42MM)', exactName: 'IWATCH SERIES 10 (42MM)', image: '/images/watches/iwatchseries941mm.jpg' },
    { name: 'IWATCH SERIES ULTRA 2 2023 (49MM)', exactName: 'IWATCH SERIES ULTRA 2 2023 (49MM)', image: '/images/watches/iwatchseriesultra2202349mm.jpg' },
    { name: 'IWATCH SERIES ULTRA 2022 (49MM)', exactName: 'IWATCH SERIES ULTRA 2022 (49MM)', image: '/images/watches/iwatchseriesultra202249mm.jpg' },
    { name: 'IWATCH SERIES 8 (45MM) (First Instance)', exactName: 'IWATCH SERIES 8 (45MM) (First Instance)', image: '/images/watches/iwatchseriesse.jpeg' },
    { name: 'IWATCH SERIES 9 (41MM)', exactName: 'IWATCH SERIES 9 (41MM)', image: '/images/watches/iwatchseries941mm.jpg' },
    { name: 'IWATCH SERIES 8 (45MM) (Second Instance)', exactName: 'IWATCH SERIES 8 (45MM) (Second Instance)', image: '/images/watches/iwatchseriesse.jpeg' },
    { name: 'IWATCH SERIES 8 (41MM)', exactName: 'IWATCH SERIES 8 (41MM)', image: '/images/watches/iwatchseries841mm.jpg' },
    { name: 'IWATCH SERIES SE (44MM) 2ND GEN 2022', exactName: 'IWATCH SERIES SE (44MM) 2ND GEN 2022', image: '/images/watches/iwatchseriesse44mm.jpg' },
    { name: 'IWATCH SERIES SE (40MM) 2ND GEN 2022', exactName: 'IWATCH SERIES SE (40MM) 2ND GEN 2022', image: '/images/watches/iwatchseriesse.jpeg' },
    { name: 'IWATCH SERIES 7 (45MM)', exactName: 'IWATCH SERIES 7 (45MM)', image: '/images/watches/iwatchseries744mm.webp' },
    { name: 'IWATCH SERIES 7 (41MM)', exactName: 'IWATCH SERIES 7 (41MM)', image: '/images/watches/iwatchseries7.jpg' },
    { name: 'IWATCH SERIES SE (44MM) (1st Gen - 2020)', exactName: 'IWATCH SERIES SE (44MM) (1st Gen - 2020)', image: '/images/watches/iwatchseriesse44mm.jpg' },
    { name: 'IWATCH SERIES SE (40MM) (1st Gen - 2020)', exactName: 'IWATCH SERIES SE (40MM) (1st Gen - 2020)', image: '/images/watches/iwatchseriesse.jpeg' },
    { name: 'IWATCH SERIES 6 (44MM)', exactName: 'IWATCH SERIES 6 (44MM)', image: '/images/watches/iwatchseries644mm.png' },
    { name: 'IWATCH SERIES 6 (40MM)', exactName: 'IWATCH SERIES 6 (40MM)', image: '/images/watches/iwatch series6.jpg' },
    { name: 'IWATCH SERIES 5 (44MM)', exactName: 'IWATCH SERIES 5 (44MM)', image: '/images/watches/iwatchseries544mm.jpg' },
    { name: 'IWATCH SERIES 5 (40MM)', exactName: 'IWATCH SERIES 5 (40MM)', image: '/images/watches/iwatchseries540mm.jpg' },
    { name: 'IWATCH SERIES 4 (44MM)', exactName: 'IWATCH SERIES 4 (44MM)', image: '/images/watches/iwatchseries444mm.jpg' },
    { name: 'IWATCH SERIES 4 (40MM)', exactName: 'IWATCH SERIES 4 (40MM)', image: '/images/watches/iwatchseries444mm.jpg' },
    { name: 'IWATCH SERIES 3 (42MM)', exactName: 'IWATCH SERIES 3 (42MM)', image: '/images/watches/iwatchseries344mm.png' },
    { name: 'IWATCH SERIES 3 (38MM)', exactName: 'IWATCH SERIES 3 (38MM)', image: '/images/watches/iwatchseries344mm.png' },
    { name: 'IWATCH SERIES 3 (42MM) GPS + CELLULAR', exactName: 'IWATCH SERIES 3 (42MM) GPS + CELLULAR', image: '/images/watches/iwatchseries344mm.png' },
    { name: 'IWATCH SERIES 3 38MM GPS + Cellular', exactName: 'IWATCH SERIES 3 38MM GPS + Cellular', image: '/images/watches/iwatchseries344mm.png' },
    { name: 'IWATCH SERIES 2 (42MM)', exactName: 'IWATCH SERIES 2 (42MM)', image: '/images/watches/iwatch series6.jpg' },
    { name: 'IWATCH SERIES 2 (38MM)', exactName: 'IWATCH SERIES 2 (38MM)', image: '/images/watches/iwatch series6.jpg' },
    { name: 'IWATCH SERIES 1 (42MM)', exactName: 'IWATCH SERIES 1 (42MM)', image: '/images/watches/iwatch series6.jpg' },
    { name: 'IWATCH SERIES 1 (38MM)', exactName: 'IWATCH SERIES 1 (38MM)', image: '/images/watches/iwatch series6.jpg' },
  ],

  // Consoles
  consoles: [
    { name: 'PlayStation 5', exactName: 'PlayStation 5', image: '/images/consoles/ps5.avif' },
    { name: 'PlayStation 4', exactName: 'PlayStation 4', image: '/images/consoles/ps4.avif' },
    { name: 'Nintendo Switch', exactName: 'Nintendo Switch', image: '/images/consoles/nintendo_switch.avif' },
    { name: 'Xbox one', exactName: 'Xbox one', image: '/images/consoles/xbox_one.avif' },
    { name: 'Xbox series', exactName: 'Xbox series', image: '/images/consoles/xbox_series.avif' },
  ],
};

// Navigation URLs remain the same
const navigationUrls = {
  brands: {
    iphone: { name: 'iPhone Repairs', url: '/phone/iphone', type: 'phone' },
    samsung: { name: 'Samsung Repairs', url: '/phone/samsung', type: 'phone' },
    pixel: { name: 'Google Pixel Repairs', url: '/phone/pixel', type: 'phone' },
    oneplus: { name: 'OnePlus Repairs', url: '/phone/oneplus', type: 'phone' },
    huawei: { name: 'Huawei Repairs', url: '/phone/huawei', type: 'phone' },
    xiaomi: { name: 'Xiaomi/Redmi Repairs', url: '/phone/xiaomi', type: 'phone' },
    motorola: { name: 'Motorola Repairs', url: '/phone/motorola', type: 'phone' },
    nokia: { name: 'Nokia Repairs', url: '/phone/nokia', type: 'phone' },
    oppo: { name: 'Oppo Repairs', url: '/phone/oppo', type: 'phone' },
    ipad: { name: 'iPad Repairs', url: '/tablet/ipad', type: 'tablet' },
    samsungtab: { name: 'Samsung Tablet Repairs', url: '/tablet/samsung', type: 'tablet' },
    iwatch: { name: 'Apple Watch Repairs', url: '/watch/iwatch', type: 'watch' },
    playstation: { name: 'PlayStation Repairs', url: '/console/playstation', type: 'console' },
    xbox: { name: 'Xbox Repairs', url: '/console/xbox', type: 'console' },
    nintendo: { name: 'Nintendo Repairs', url: '/console/nintendo', type: 'console' },
  },
  services: {
    'screen-replacement': { name: 'Screen Replacement', url: '/services/screen-replacement' },
    'battery-replacement': { name: 'Battery Replacement', url: '/services/battery-replacement' },
    'charging-port': { name: 'Charging Port Repair', url: '/services/charging-port' },
    'water-damage': { name: 'Water Damage Repair', url: '/services/water-damage' },
  }
};

// Create allSearchableItems array for search functionality
const allSearchableItems = [];

// Add all devices from searchData
Object.keys(searchData).forEach(category => {
  searchData[category].forEach(item => {
    allSearchableItems.push({
      ...item,
      category: category,
      type: category.includes('iphone') ? 'Phone' : 
            category.includes('samsung') && !category.includes('tab') ? 'Phone' :
            category.includes('pixel') ? 'Phone' :
            category.includes('oneplus') ? 'Phone' :
            category.includes('huawei') ? 'Phone' :
            category.includes('xiaomi') ? 'Phone' :
            category.includes('motorola') ? 'Phone' :
            category.includes('nokia') ? 'Phone' :
            category.includes('oppo') ? 'Phone' :
            category.includes('ipad') || category.includes('tab') ? 'Tablet' :
            category.includes('iwatch') ? 'Watch' :
            category.includes('consoles') ? 'Console' : 'Other'
    });
  });
});

// Add navigation items (brand pages)
Object.keys(navigationUrls.brands).forEach(brand => {
  allSearchableItems.push({
    name: navigationUrls.brands[brand].name,
    url: navigationUrls.brands[brand].url,
    type: navigationUrls.brands[brand].type || 'Brand',
    category: 'navigation'
  });
});

// Add service pages
Object.keys(navigationUrls.services).forEach(service => {
  allSearchableItems.push({
    name: navigationUrls.services[service].name,
    url: navigationUrls.services[service].url,
    type: 'Service',
    category: 'service'
  });
});

export { searchData, navigationUrls, allSearchableItems };
